<template>
	<div class="container">
		<top :currentComponent="currentComponent" @Select="Select" :topList="topList"></top>
		<component :ref="currentComponent" :is="currentComponent"></component>
	</div>
</template>
<script>
import top from "@/views/mechanism/children/top";
import allOrder from './components/myDealChild/allOrder'
import sonOrder from './components/myDealChild/sonOrder'
import invoiceManager from './components/myDealChild/invoiceManager'
import evaluateManager from './components/myDealChild/evaluateManager'
import questionsManager from './components/myDealChild/questionsManager'
import refuseRequest from './refuseRequest.vue'
import transferOutManagement from "@/views/mechanism/components/myDealChild/transferOutManagement.vue";
export default {
	components: {
		top,
		allOrder,
		sonOrder,
		invoiceManager,
		evaluateManager,
		questionsManager,
        refuseRequest,
        transferOutManagement
	},
	data() {
		return {
			topList: [{
				name: "全部订单",
				to: "allOrder",
			},
			{
				name: "子订单",
				to: "sonOrder",
			},
			{
				name: "发票管理",
				to: "invoiceManager",
			},
			{
				name: "退款管理",
				to: "refuseRequest",
			},
            {
                name: "转出管理",
                to: "transferOutManagement",
            },
			{
				name: "评价管理",
				to: "evaluateManager",
			},
			{
				name: "问答管理",
				to: "questionsManager",
			},
			{
				name: "交易预警",
				to: "/暂未开发",
			},
			{
				name: "恶意订单管理",
				to: "/暂未开发",
			},
			{
				name: "维权中心",
				to: "/暂未开发",
			},
			],
			currentComponent: 'allOrder',
		}
	},
	methods: {
		Select(val) {
			this.currentComponent = val
		}
	},
	distroyed() {
		this.$Bus.$off("pagesSW")
	},
	mounted() {
		this.$Bus.$on("pagesSW", (data) => {
			this.currentComponent = data.currentComponent
			this.$nextTick(() => {
				if (data.buttom) {
					this.$set(this.$refs[data.currentComponent], 'activeName', data.buttom)
				}
				if (data.httpObj) {
					this.$refs[data.currentComponent].init.q = { ...this.$refs[data.currentComponent].init.q, ...data.httpObj }
				}
			})
		});
		let data = this.$route.query
		let flag = this.topList.findIndex(n => n.to === data.currentComponent)
		if (JSON.stringify(data) !== '{}' && flag !== -1) {
			this.currentComponent = data.currentComponent
			if (data.currentComponent === 'invoiceManager' || data.currentComponent === 'transferOutManagement') {
				this.$nextTick(() => {
					this.$refs[data.currentComponent].init.q = { ...this.$refs[data.currentComponent].init.q, ... JSON.parse(data.httpObj)}
				})
			}
		}
		this.$router.replace({ query: {} })
	},
}
</script>

<style lang="scss" scoped>
.container {
	width: 100%;
	min-height: 8rem;
}
</style>
